<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :persistent="options.persistent"
    @keydown.esc="cancel"
  >
    <data-card
      :color="options.color"
      :colored-border="options.coloredBorder"
      :dark="options.dark"
      :dense="options.dense"
      :icon="options.icon"
      :sub-title="subTitle"
      :title="title"
      tile
    >
      <template #toolbar-append>
        <v-btn
          color="brand-green-dark"
          icon
          large
          outlined
          style="background-color: var(--v-brand-card-bg-base);"
          @click.native="cancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>

      <template #default>
        <v-card-text class="pa-4 text-body brand-green-dark--text">
          <slot name="default">
            <div
              v-safe-html="message"
              class="text-md-body-1"
            />
          </slot>

          <div
            v-if="options.selectTime"
            class="mt-2 pb-4 caption"
          >
            <div>{{ $t(`Bookings.Form.Fields.Time.Hint`) }}<span style="color: red">*</span></div>
            <v-menu
              ref="timeMenu"
              v-model="timeDialogVisible"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="selectedTime"
              max-width="290px"
              min-width="290px"
              offset-y
              transition="scale-transition"
            >
              <template #activator="{on, attrs}">
                <v-text-field
                  v-model="selectedTime"
                  clearable
                  color="black"
                  dense
                  outlined
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="timeDialogVisible"
                v-model="selectedTime"
                color="opelyellow"
                format="24hr"
                full-width
                @click:minute="$refs.timeMenu.save(selectedTime)"
              />
            </v-menu>
          </div>

          <div
            v-if="options.reason && options.reasons && options.reasons.items && options.reasons.items.length"
            class="mt-2 pb-4 caption"
          >
            <v-select
              v-model="selectedReason"
              :items="options.reasons.items"
              :label="options.reasons.label"
              clearable
              item-text="Name"
              item-value="Id"
              outlined
              prepend-inner-icon="mdi-comment-processing"
              return-object
              @change="reason = ''"
            />

            <v-text-field
              v-if="options.reason && selectedReason && selectedReason.Id === -1"
              v-model="reason"
              :label="options.reason.label"
              clearable
              hide-details
              outlined
              prepend-inner-icon="mdi-comment-processing"
            />
          </div>

          <div
            v-if="options.validate"
            class="mt-5 caption"
          >
            <span v-safe-html="options.validate.text" />
            <v-text-field
              v-model="answer"
              :color="options.color"
              clearable
              filled
              hide-details
              prepend-inner-icon="mdi-lock"
              single-line
            />
          </div>
          <div
            v-if="options.input"
            class="mt-5 caption"
          >
            <span v-safe-html="options.input" />
            <v-text-field
              v-model="input"
              :color="options.color"
              clearable
              filled
              hide-details
              prepend-inner-icon="mdi-lock"
              single-line
            />
          </div>
        </v-card-text>
      </template>

      <template #card-actions>
        <v-divider />
        <v-card-actions class="brand-text-title">
          <slot name="card-actions">
            <v-spacer />
            <v-btn
              v-if="options.button.no"
              color="grey"
              outlined
              tile
              @click="cancel"
            >
              {{ options.button.no.title }}
            </v-btn>

            <v-btn
              v-if="options.button.yes"
              :color="options.color"
              :dark="isNotValid ? false : options.dark"
              :disabled="isNotValid"
              depressed
              tile
              @click="confirm"
            >
              {{ options.button.yes.title }}
            </v-btn>
          </slot>
        </v-card-actions>
      </template>
    </data-card>
  </v-dialog>
</template>

<script>
import ConfirmDialogMixin from '@/theme/default/components/common/ConfirmDialog.js'

export default {
  name  : 'ConfirmDialog',
  mixins: [ConfirmDialogMixin]
}
</script>


<style scoped src="@/theme/default/components/common/ConfirmDialog.css"></style>

<style scoped>
</style>
